import { DataCard } from "components/common/DataCard";
import { VisibleSection } from "components/common/VisibleSection";
import { LoanDetails } from "domain/yourBBLS";
import {
  PAYG_OPTIONS_LINE1,
  PAYG_OPTIONS_LINE2,
  PAYG_OPTIONS_LINE3,
  RH_TEXT2,
} from "./Landing.const";

type YourAvailableOptionsProps = {
  loanDetails: LoanDetails;
};

export const YourAvailableOptions = ({
  loanDetails: { fullTermExtensionTaken },
}: YourAvailableOptionsProps) => (
  <div className="your-available-options section-margin">
    <DataCard header="Your Pay as you Grow (PAYG) options">
      <p>{PAYG_OPTIONS_LINE1}</p>
      <p>{PAYG_OPTIONS_LINE2}</p>
      <p>{PAYG_OPTIONS_LINE3}</p>
      <p>
        You can take up to <strong>3 Capital repayment holidays</strong> and
        <strong> 1 Capital & Interest repayment holiday</strong> during your
        loan.
      </p>
      <ul>
        <li>
          <span>
            These repayment holidays are in addition to the
            <strong> 12 month repayment holiday</strong> you had at the start of
            your loan
          </span>
        </li>
        <li>
          <span>{RH_TEXT2}</span>
        </li>
        <VisibleSection visible={!fullTermExtensionTaken}>
          <>
            <p className="pt-3">
              You can <strong>extend the term of your loan</strong> so that your
              final repayment is 10 years after you took out the loan.
            </p>
            <ul>
              <li>
                <span>
                  Extending the term of your loan will allow you to{" "}
                  <strong>repay a smaller amount each month</strong>
                </span>
              </li>
              <li>
                <span>
                  <strong>The total amount you owe will go up</strong> if you
                  extend the term of your loan
                </span>
              </li>
              <li>
                <span>
                  <strong>You can only do this once</strong> during the life of
                  your loan
                </span>
              </li>
            </ul>
          </>
        </VisibleSection>
      </ul>
    </DataCard>
  </div>
);
